export const SELECT_USER = 'SELECT_USER'; // 当前选择的用户